import { render, staticRenderFns } from "./TheModals.vue?vue&type=template&id=dfd8235e"
import script from "./TheModals.vue?vue&type=script&lang=js"
export * from "./TheModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports